<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessages.length > 0"
    :show="true"
    :messages="errorMessages"
  />
  <div v-else>
    <b-row>
      <b-col lg="4" cols="12">
        <b-card class="mb-4" title="برنامه" title-tag="h5">
          <b-row>
            <b-col cols="4" lg="12">
              <b-img
                center
                width="150"
                height="150"
                :src="service.picture"
                fluid
                alt="Responsive image"
                rounded="circle"
              />
            </b-col>
            <b-col cols="8" lg="12" class="d-flex align-items-center">
              <b-row>
                <b-col cols="6" class="mb-2">
                  <div class="d-flex align-items-center mb-3">
                    <b-icon
                      icon="key"
                      font-scale="2"
                      variant="warning"
                      rotate="-90"
                      class="ml-3"
                    ></b-icon>
                    <div class="d-flex flex-column">
                      <small class="d-flex mb-2 text-muted">
                        شناسه برنامه
                      </small>
                      <span>{{ service.name }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6" class="mb-2">
                  <div class="d-flex align-items-center mb-3">
                    <b-icon
                      icon="files"
                      font-scale="2"
                      variant="warning"
                      class="ml-3"
                    ></b-icon>
                    <div class="d-flex flex-column">
                      <span class="d-flex mb-2 text-muted">
                        نسخه برنامه
                      </span>
                      <span>{{ service.version }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6">
                  <b-link :href="service.url" target="_blank">
                    نمایش سایت
                  </b-link>
                </b-col>
                <b-col cols="6">
                  <b-button
                    size="sm"
                    class="d-flex align-items-center"
                    v-if="service.status === 1"
                    variant="outline-success"
                    @click="ChangeStatus"
                    v-b-tooltip.hover
                    title="برای خاموش کردن کلیک کنید."
                  >
                    <b-icon icon="power" class="ml-1" /> آماده به کار
                  </b-button>
                  <b-button
                    size="sm"
                    class="d-flex align-items-center"
                    v-else
                    variant="outline-danger"
                    @click="ChangeStatus"
                    v-b-tooltip.hover
                    title="برای روشن کردن کلیک کنید."
                  >
                    <b-icon icon="power" class="ml-1" /> خاموش
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="8" cols="12">
        <b-card class="mb-4" title="اطلاعات بیشتر" title-tag="h5">
          <b-row>
            <b-col v-for="(item, i) in moreInfoList" :key="i" cols="12" sm="6">
              <div
                v-if="item.id === 'price'"
                class="d-flex align-items-center mb-3"
              >
                <b-icon
                  :icon="item.icon"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                ></b-icon>
                <div class="d-flex flex-column">
                  <small class="d-flex mb-2 text-muted">
                    {{ item.type }}
                  </small>
                  <span>
                    {{ item.value }}&nbsp;{{ item.unit }}
                    <b-badge
                      variant="success"
                      to="/payment/add"
                      class="mr-md-2"
                    >
                      افزایش اعتبار
                    </b-badge>
                  </span>
                </div>
              </div>
              <div v-else class="d-flex align-items-center mb-3">
                <b-icon
                  :icon="item.icon"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                ></b-icon>
                <div class="d-flex flex-column">
                  <small class="d-flex mb-2 text-muted">
                    {{ item.type }}
                  </small>
                  <span> {{ item.value }}&nbsp;{{ item.unit }} </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mb-4" title="منابع انتخاب شده" title-tag="h5">
          <b-row>
            <b-col v-for="(item, i) in resourceList" :key="i" cols="12" sm="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  :icon="item.icon"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                ></b-icon>
                <div class="d-flex flex-column">
                  <small class="d-flex mb-2 text-muted">
                    {{ item.type }}
                  </small>
                  <span> {{ item.value }}&nbsp;{{ item.unit }} </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { userServiceDetails, changeServiceStatus } from "@/services/service";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  components: { Loading, ErrorMessages },
  name: "AppDetails",
  data() {
    return {
      loading: false,
      errorMessages: "",
      service: {
        url: "",
        name: "",
        picture: "",
        version: "",
        status: 1
      },
      moreInfoList: [
        {
          id: "url",
          type: "آدرس سایت",
          icon: "globe",
          value: "",
          unit: ""
        },
        {
          id: "price",
          type: "هزینه",
          icon: "cash",
          value: "",
          unit: "ریال ساعتی"
        },
        {
          id: "location",
          type: "موقعیت",
          icon: "geo-alt",
          value: "ایران",
          unit: ""
        },
        {
          id: "createdAt",
          type: "تاریخ ایجاد",
          icon: "calendar2-check",
          value: "",
          unit: ""
        }
      ],
      resourceList: [
        {
          id: "cpu",
          type: "پردازنده (CPU)",
          icon: "cpu",
          value: "",
          unit: "هسته"
        },
        {
          id: "ram",
          type: "حافظه اصلی (RAM)",
          icon: "border-style",
          value: "",
          unit: "گیگابایت"
        },
        {
          id: "storage",
          type: "فضا (HDD)",
          icon: "hdd",
          value: "",
          unit: "گیگابایت"
        },
        {
          id: "trafic",
          type: "ترافیک",
          icon: "bar-chart",
          value: "نامحدود",
          unit: ""
        }
      ]
    };
  },
  mounted() {
    this.getDetailsApp();
  },
  methods: {
    getDetailsApp: async function() {
      this.loading = true;
      const [error, data] = await userServiceDetails(
        this.$route.params.serviceId
      );
      if (error) {
        this.errorMessages = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          let {
            url,
            name,
            picture,
            version,
            status,
            ram,
            cpu,
            storage,
            price,
            createdAt
          } = data.apiData;
          // resource List
          let tempResourceList = [...this.resourceList];
          tempResourceList.map(item => {
            switch (item.id) {
              case "ram":
                item["value"] = ram;
                break;
              case "cpu":
                item["value"] = cpu;
                break;
              case "storage":
                item["value"] = storage;
                break;
            }
          });
          this.resourceList = [...tempResourceList];
          // more Info List
          let tempMoreInfoList = [...this.moreInfoList];
          tempMoreInfoList.map(item => {
            switch (item.id) {
              case "price":
                item["value"] = price;
                break;
              case "createdAt":
                item["value"] = createdAt;
                break;
              case "url":
                if (!url) {
                  item["value"] = `http://${name}.cv9.ir`;
                } else {
                  item["value"] = url;
                }
                break;
            }
          });
          this.moreInfoList = [...tempMoreInfoList];
          // service Object
          if (!url) {
            url = `http://${name}.cv9.ir`;
          }
          picture = picture.replace("files", "file");
          this.service = { url, name, picture, version, status };
          this.loading = false;
        } else {
          this.errorMessages = data.apiErrors;
          this.loading = false;
        }
      }
    },
    ChangeStatus: async function() {
      const [error, data] = await changeServiceStatus({
        serviceId: this.$route.params.serviceId
      });
      if (!error) {
        if (data.apiStatus === 200) {
          this.service.status = data.apiData.status;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.details-image-layout {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;

  &-btn {
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    & svg {
      margin-left: 10px;
    }
  }
}
.details-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.details-image {
  width: 150px;
  height: 150px;
}
</style>
